import type { Command } from 'prosemirror-state';

import { NodeName } from '../../../schema/nodes';
import type { VideoNodeAttrs } from '../nodes/video-node.types';

export const createVideoCommand = ({ src, width, height }: VideoNodeAttrs): Command =>
  function (state, dispatch) {
    const { tr, selection, schema } = state;
    const pos = selection.from;

    const node = schema.nodes[NodeName.Video].create({
      src,
      width: width || null,
      height: height || null,
    });
    tr.insert(pos, node);
    if (dispatch) dispatch(tr);
    return true;
  };
